import NotFound from 'components/NotFound';
import AdminUsersTable from 'components/admin/pages/Users/AdminUsersTable';
import AdminUserLogs from 'components/admin/pages/Users/Logs';
import AdminUserOverview from 'components/admin/pages/Users/Overview';
import AdminUserSessions from 'components/admin/pages/Users/Sessions';
import AdminUserUser from 'components/admin/pages/Users/User';

const ADMIN_USERS = [
  {
    path: 'users',
    element: <AdminUsersTable />,
    children: [
      {
        path: ':id',
        element: <AdminUserUser />,
        children: [
          {
            path: '',
            element: <AdminUserOverview />
          },
          {
            path: 'logs',
            element: <AdminUserLogs />
          },
          {
            path: 'sessions',
            element: <AdminUserSessions />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default ADMIN_USERS;
